const GROUPS = [
  ["METH & DRUG SUPPORT", "0800 METH HELP 0800 787 797 · Māori 0800 787 798 · Pasifika 0800 787 799 · Youth 0800 787 984"],
  ["SOMEONE TO TALK TO", "Call or text 1737 · Text 8681 · Youthline 0800 376 633 · Canterbury crisis 0800 920 092"],
  ["URGENT HELP", "Emergency 111 · Are You OK (whānau violence) 0800 456 450"],
];

const CARD_W = 1050;
const CARD_H = 600;

function wrapLines(ctx, text, maxWidth) {
  const words = text.split(" ");
  const out = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) { out.push(line); line = w; } else line = test;
  }
  if (line) out.push(line);
  return out;
}

async function paintCard(ctx, W, H) {
  ctx.fillStyle = "#090A0F";
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#EF4444";
  ctx.fillRect(0, 0, 14, H);

  const logo = new Image();
  logo.src = "/logo-mark.png";
  let lw = 0;
  const lh = 72;
  try {
    await logo.decode();
    lw = lh * (logo.width / logo.height);
    ctx.drawImage(logo, 56, 44, lw, lh);
  } catch { /* logo optional */ }

  ctx.textAlign = "left";
  ctx.fillStyle = "#F5F2EC";
  ctx.font = '700 44px "Space Grotesk", sans-serif';
  ctx.fillText("NEED TO TALK?", 56 + lw + 26, 84);
  ctx.fillStyle = "#EF4444";
  ctx.font = '500 21px "JetBrains Mono", monospace';
  ctx.fillText("FREE · CONFIDENTIAL · 24/7", 56 + lw + 26, 118);

  let y = 178;
  for (const [label, content] of GROUPS) {
    ctx.fillStyle = "#EF4444";
    ctx.font = '500 19px "JetBrains Mono", monospace';
    ctx.fillText(label, 56, y);
    ctx.fillStyle = "#F5F2EC";
    ctx.font = '600 25px "Space Grotesk", sans-serif';
    y += 36;
    for (const line of wrapLines(ctx, content, W - 130)) {
      ctx.fillText(line, 56, y);
      y += 34;
    }
    y += 28;
  }

  ctx.fillStyle = "#EF4444";
  ctx.fillRect(0, H - 64, W, 64);
  ctx.textAlign = "center";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = '700 24px "Space Grotesk", sans-serif';
  ctx.fillText("NO TO METH — IT LEADS TO DEATH · breakthecyclemovement.com", W / 2, H - 24);
}

export async function renderWalletCard() {
  await document.fonts.ready;
  const canvas = document.createElement("canvas");
  canvas.width = CARD_W;
  canvas.height = CARD_H;
  await paintCard(canvas.getContext("2d"), CARD_W, CARD_H);
  return canvas;
}

export async function renderPrintSheet() {
  const card = await renderWalletCard();
  const W = 1240;
  const H = 1754;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#F5F2EC";
  ctx.fillRect(0, 0, W, H);

  ctx.textAlign = "center";
  ctx.fillStyle = "#1A1A1A";
  ctx.font = '600 27px "Space Grotesk", sans-serif';
  ctx.fillText("BREAK THE CYCLE MOVEMENT — helpline cards", W / 2, 58);

  const margin = 60;
  const gap = 24;
  const cols = 2;
  const rows = 4;
  const cw = (W - margin * 2 - gap) / cols;
  const ch = cw * (CARD_H / CARD_W);
  const startY = 90;
  ctx.setLineDash([7, 7]);
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const x = margin + c * (cw + gap);
      const y = startY + r * (ch + gap);
      ctx.drawImage(card, x, y, cw, ch);
      ctx.strokeStyle = "#B9B3A8";
      ctx.lineWidth = 1;
      ctx.strokeRect(x, y, cw, ch);
    }
  }
  ctx.setLineDash([]);
  ctx.fillStyle = "#71717A";
  ctx.font = '400 20px "Space Grotesk", sans-serif';
  ctx.fillText("Cut along the dashed guides · breakthecyclemovement.com", W / 2, H - 28);
  return canvas;
}

export function downloadHelplineCard(canvas, name) {
  canvas.toBlob((blob) => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${name}.png`;
    a.click();
    URL.revokeObjectURL(a.href);
  }, "image/png");
}
